import { customerMarketShopfrontApi } from '@envato/foundation-types'

const itemAspectRatio = (item: customerMarketShopfrontApi.search.Match) => {
  if (!item.image_urls || item.image_urls.length <= 0) {
    return null
  }

  return item.image_urls[0].width / item.image_urls[0].height
}

export default itemAspectRatio
